import { PostCardStack } from './post-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { GenericPostCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/generic-post-card-stack-background/generic-post-card-stack-background.component';
import { GenericPostCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/generic-post-card-stack-content/generic-post-card-stack-content.component';
import type { CardData } from '../../../../print-cards/card-data';

export class GenericPostCardStack extends PostCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> {
    return GenericPostCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> {
    return GenericPostCardStackContentComponent;
  }
}
